import { Box, Heading } from '@chakra-ui/react';
import React from 'react';

import { DeliverableContainerReceiptRecordGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { DeliverableReceiptsInputTable } from '../borrower/DeliverableReceiptsInputTable';
import { colors } from 'packages/common-frontend/colors';
import { HighlightBox } from 'packages/common-frontend/components/HighlightBox';

export const DigitalMonthlyReportInputs = ({
  currentReceipt,
}: {
  currentReceipt: DeliverableContainerReceiptRecordGQLType;
}) => {
  return (
    <HighlightBox backgroundColor={colors.millet[50]}>
      <Heading as="h2" fontSize="24px" mb="24px">
        Inputs
      </Heading>
      <Box
        backgroundColor="white"
        borderRadius="8px"
        borderWidth="1px"
        borderColor={colors.gray[200]}
        padding="40px"
        w="100%"
      >
        <DeliverableReceiptsInputTable currentReceipt={currentReceipt} />
      </Box>
    </HighlightBox>
  );
};
